import React, { useEffect, useState } from "react";
import ReusableTable from "components/Tables/ReusableTable";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
    Box,
    Flex,
    Text,
    Badge,
} from "@chakra-ui/react";
import {
    Eye,
    EllipsisVertical,
} from "lucide-react";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import ViewPrivacySettings from "./components/ViewPrivacySettings";
import { formatDate } from "utils/dateFormatter";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { fetchPrivacySettingsAction } from "state/actions/privacySettingsActions";
import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";

const UserPrivacySettingsTab = () => {
    const dispatch = useDispatch();
    const { settings = null, loading = null } = useSelector(
        (state) => state.privacySettings || {}
    );


    const [isViewDrawerOpen, setViewDrawerOpen] = useState(false);
    const [selectedSetting, setSelectedSetting] = useState(null);

    useEffect(() => {
        dispatch(fetchPrivacySettingsAction());
    }, [dispatch]);

    const handleViewSetting = (setting) => {
        setSelectedSetting(setting);
        setViewDrawerOpen(true);
    };

    const generateMenuItems = (row) => [
        {
            icon: <Eye size={16} />,
            text: "View",
            onClick: () => handleViewSetting(row.original),
        },
    ];

    const getFullName = (userInfo) => {
        if (!userInfo) return "N/A";
        const { first_name, middle_name, last_name, username } = userInfo;

        // fallback: if all names null, use username or "N/A"
        if (!first_name && !middle_name && !last_name) return username || "N/A";

        // join parts that exist, trim spaces
        return [first_name, middle_name, last_name].filter(Boolean).join(" ").trim();
    };


    const columnsData = [
        {
            Header: "Full Name",
            accessor: (row) => getFullName(row.user_info),
            id: "fullName", // required for accessor function columns
            Cell: ({ value }) => <Text isTruncated maxWidth="200px">{value}</Text>,
        },

        {
            Header: "Date Created",
            accessor: "created_at",
            Cell: ({ value }) => formatDate(value),
        },
        {
            Header: "Updated At",
            accessor: "updated_at",
            Cell: ({ value }) => formatDate(value),
        },
      {
    Header: "Status",
    accessor: "user_info.status",
    Cell: ({ value }) => (
        <StatusBadge
            label={value}
            variant={getStatusVariant(value)}
        />
    ),
},

        {
            Header: "Actions",
            accessor: "actions",
            Cell: ({ row }) => (
                <ThreeDotMenu
                    icon={<EllipsisVertical size={20} color="grey" />}
                    items={generateMenuItems(row)}
                />
            ),
        },
    ];

    return (
        <Box>
            <Flex justifyContent="end" mb={4}>
                {loading && <Skeleton width="120px" height="40px" borderRadius="md" />}
            </Flex>

            <ReusableTable columnsData={columnsData} tableData={settings || []} isLoading={loading} />

            {isViewDrawerOpen && selectedSetting && (
                <ReusableDrawer
                    isOpen={isViewDrawerOpen}
                    onClose={() => setViewDrawerOpen(false)}
                    headerContent={<Text fontWeight="bold" fontSize="lg">Privacy Setting Details</Text>}
                    bodyContent={<ViewPrivacySettings privacySettings={selectedSetting.privacy_settings} userInfo={selectedSetting.user_info} />}
                />
            )}


        </Box>
    );
};

export default UserPrivacySettingsTab;
